<template>
    <div class="box">
        <div class="is-size-5 mb-2 is-flex is-justify-content-space-between">
            <div>
                {{ translateVendor(liveStream.vendor) }}
            </div>

            <div>
                <span class="icon">
                    <i class="fa fa-video" />
                </span>
                <span> {{ translate("common.mat") }}: {{ getMatName(liveStream.matId) }} </span>
            </div>
        </div>

        <BasicYoutube v-if="liveStream.vendor === 'BasicYoutube'" :live-stream="liveStream" />

        <div class="buttons are-small">
            <a class="button" :href="getUrlToLiveStreams()" target="_blank">
                <span class="icon">
                    <i class="fa fa-eye" />
                </span>
                <span>
                    {{ translate("live_streams.visit_stream_page") }}
                </span>
            </a>
            <LoadingButton
                :is-loading="deletingInProgress === liveStream.id"
                class="button is-danger"
                @click="deleteLiveStream(liveStream.id)"
            >
                <span class="icon">
                    <i class="fa fa-trash" />
                </span>
                <span>
                    {{ translate("common.delete") }}
                </span>
            </LoadingButton>
        </div>
    </div>
</template>

<script>
    import LoadingButton from "../Common/LoadingButton.vue";
    import translatorMixin from "../Common/translatorMixin";
    import { mapState } from "vuex";
    import apiMixin from "../Api/apiMixin";
    import errorHandlerMixin from "../Common/errorHandlerMixin";
    import BasicYoutube from "./BasicYoutube.vue";
    import urlsMixin from "../Urls/urlsMixin";
    import toastMixin from "../Common/toastMixin";

    export default {
        name: "live-stream",
        components: { BasicYoutube, LoadingButton },
        mixins: [translatorMixin, apiMixin, errorHandlerMixin, urlsMixin, toastMixin],
        props: ["liveStream"],
        data() {
            return {
                deletingInProgress: "",
            };
        },
        computed: {
            ...mapState("main", ["eventId", "mats"]),
        },
        methods: {
            getMatName(matId) {
                const mat = this.mats.find(m => m.id === matId);
                return mat ? mat.name : "";
            },
            deleteLiveStream(liveStreamId) {
                this.deletingInProgress = liveStreamId;
                return this.liveStreamsApi()
                    .deleteLiveStream(this.eventId, liveStreamId)
                    .then(() => {
                        this.$store.dispatch("main/refreshLiveStreams");
                    })
                    .then(() => {
                        this.successToast(this.translate("live_streams.deleted"));
                    })
                    .catch(this.handleError)
                    .finally(() => {
                        this.deletingInProgress = "";
                    });
            },
            translateVendor(vendor) {
                return this.translate(`live_streams.vendor.${vendor}`);
            },
            getUrlToLiveStreams() {
                return this.publicEventPages(this.eventId, "slug").liveStreamsUrl();
            },
        },
    };
</script>

<style scoped></style>
